import { CompetitorMgItemPriceDTO } from '../../dto';

export interface CompetitorMgItemPrice {
  mgItemNumber: number;
  equivalentMgItemNumber?: number;
  retailerNumber: number;
  retailerName: string;
  urlName: string;
  storeNumber: number;
  storeName: string;
  url?: string;
  price?: number;
  lastObserved?: string;
  previousPrice?: number;
  previousLastObserved?: string;
  unit?: string;
  onDiscount: boolean;
}

export const competitorMgItemPriceFromDto = (
  dto: CompetitorMgItemPriceDTO
): CompetitorMgItemPrice => ({
  mgItemNumber: dto.mgItemNumber,
  equivalentMgItemNumber: dto.equivalentMgItemNumber ?? undefined,
  retailerNumber: dto.retailerNumber,
  retailerName: dto.retailerName,
  urlName: dto.urlName,
  storeNumber: dto.storeNumber,
  storeName: dto.storeName,
  url: dto.url ?? undefined,
  price: dto.price ?? undefined,
  lastObserved: dto.lastObserved ?? undefined,
  previousPrice: dto.previousPrice ?? undefined,
  previousLastObserved: dto.previousLastObserved ?? undefined,
  unit: dto.unit ?? undefined,
  onDiscount: !!dto.onDiscount,
});
